import { FC, lazy, Suspense } from 'react';

import { SkeletonLoader } from 'components/_basic/SkeletonLoader';

const OnePageSecondStyleViewLazy = lazy(() =>
  import('./OnePageSecondStyle').then((module) => ({ default: module.OnePageSecondStyle })),
);

export const OnePageSecondStyleView: FC = () => (
  <Suspense fallback={<SkeletonLoader />}>
    <OnePageSecondStyleViewLazy />
  </Suspense>
);
